import { render, staticRenderFns } from "./ProductTemplateDiff.vue?vue&type=template&id=677bb96b"
import script from "./ProductTemplateDiff.vue?vue&type=script&lang=js"
export * from "./ProductTemplateDiff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports